import type { TagProps } from '../../Tag';

function hitTagMapper(
  names: string[],
  type: TagProps['type'],
): TagProps[] {
  const tagItems = names?.map((name) => (
    {
      name,
      type,
    }
  ));

  return tagItems || [];
}

export default hitTagMapper;
